
import { BaseAppConfig } from 'lib-customizations/types'

import { env, Env } from './env'

type AppConfigs = {
  default: BaseAppConfig
} & {
  [k in Env]: BaseAppConfig
}

const employeeConfigs: AppConfigs = {
  default: {
    sentry: {
      dsn: 'https://459e0ee28e5a435db1e691cc9a0ec7ee@sentry.haltu.net/39',
      enabled: true,
    },
  },
  staging: {
    sentry: {
      dsn: 'https://459e0ee28e5a435db1e691cc9a0ec7ee@sentry.haltu.net/39',
      enabled: true,
    },
  },
  prod: {
    sentry: {
      dsn: 'https://459e0ee28e5a435db1e691cc9a0ec7ee@sentry.haltu.net/39',
      enabled: true,
    },
  },
}

const employeeMobileConfigs: AppConfigs = {
  default: {
    sentry: {
      dsn: 'https://459e0ee28e5a435db1e691cc9a0ec7ee@sentry.haltu.net/39',
      enabled: true,
    },
  },
  staging: {
    sentry: {
      dsn: 'https://459e0ee28e5a435db1e691cc9a0ec7ee@sentry.haltu.net/39',
      enabled: true,
    },
  },
  prod: {
    sentry: {
      dsn: 'https://459e0ee28e5a435db1e691cc9a0ec7ee@sentry.haltu.net/39',
      enabled: true,
    },
  },
}

const citizenConfigs: AppConfigs = {
  default: {
    sentry: {
      dsn: 'https://459e0ee28e5a435db1e691cc9a0ec7ee@sentry.haltu.net/39',
      enabled: true,
    },
  },
  staging: {
    sentry: {
      dsn: 'https://459e0ee28e5a435db1e691cc9a0ec7ee@sentry.haltu.net/39',
      enabled: true,
    },
  },
  prod: {
    sentry: {
      dsn: 'https://459e0ee28e5a435db1e691cc9a0ec7ee@sentry.haltu.net/39',
      enabled: true,
    },
  },
}

const employeeConfig = employeeConfigs[env()]
const employeeMobileConfig = employeeMobileConfigs[env()]
const citizenConfig = citizenConfigs[env()]

export { employeeConfig, employeeMobileConfig, citizenConfig }
